import { type LocationsEnabled } from '@/modules/location/constants.ts';

export function getStripeCurrencyCode(countryCode: keyof LocationsEnabled) {
  switch (countryCode) {
    case 'au': {
      return 'AUD';
    }
    case 'de': {
      return 'EUR';
    }
    case 'fr': {
      return 'EUR';
    }
    case 'gb': {
      return 'GBP';
    }
    case 'it': {
      return 'EUR';
    }
    case 'ie': {
      return 'EUR';
    }
    case 'us': {
      return 'USD';
    }
    case 'nz': {
      return 'NZD';
    }
    case 'ca': {
      return 'CAD';
    }
    default: {
      return 'USD';
    }
  }
}

export function getStripeCountryCode(countryCode: keyof LocationsEnabled) {
  switch (countryCode) {
    case 'au': {
      return 'AU';
    }
    case 'de': {
      return 'DE';
    }
    case 'fr': {
      return 'FR';
    }
    case 'gb': {
      return 'GB';
    }
    case 'it': {
      return 'IT';
    }
    case 'us': {
      return 'US';
    }
    case 'ie': {
      return 'IE';
    }
    case 'ca': {
      return 'CA';
    }
    case 'nz': {
      return 'NZ';
    }
    default: {
      return 'US';
    }
  }
}
